// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"361":"56645545","594":"032f85b4","648":"ddd8d77f"}[chunkId] + ".css";
};